import { Injectable } from '@angular/core';

@Injectable()
export class OrganizationService {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/onboarding/services/organization.service.ts